import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './css/bootstrap/bootstrap.min.css';
import './css/aos.css';
import './css/jquery.fancybox.css';
import './css/swiper.css';
import './css/global.css';
import './css/theme-color.css';

const root = createRoot(document.getElementById("root"));
root.render(<App />);
